import * as React from 'react';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import Drawer from 'antd/lib/drawer';
import useInput from 'src/hooks/form/useInput';
import { validateEmail } from 'src/utils/utils';
import TagsInput from 'src/components/common/TagsInput';
import { shareDocuments } from 'src/api/shipmentExecution';
import ApiDto from 'src/dto/ApiDto';
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import GenericHoc from 'src/components/hoc/GenericHoc';
import Asterisk from 'src/components/common/Asterisk';

const styles = theme => ({
  tableGrid: {
    display: 'grid',
    marginTop: '20px',
    marginBottom: '20px',
    backgroundColor: 'white',
    gridTemplateColumns: '1fr 2fr',
    alignItems: 'center',
    gridRowGap: '10px',
    '& .ant-form-item': {
      marginBottom: '0px',
    },
    '& .ant-form-item-control': {
      lineHeight: '0px',
    },
  },
  drawer:{
    // '& .ant-drawer-content-wrapper': {
    //   height: 'fit-content',
    //   top: 157,
    // },
  },
  hrElement: {
    border: 'none',
    borderTop: '1px double #EDEDED',
    color: '#EDEDED',
    marginBottom: theme.spacing.md,
  },
});

const SEDocumentsShareModal = ({
  form,
  classes,
  visible,
  onClose,
  title = 'Share',
  documents,
  shipmentId,
}: {
  [key: string]: any,
}) => {

  const { getFieldDecorator, validateFields } = form;

  const subject = useInput({
    form,
    disabled: false,
    visible: true,
    key: "subject",
    label: "Subject",
    placeholder: "Add subject",
    formOptions: {
      rules: [{ required: true, message: "Please add subject" }],
    },
  });

  const addMessage = useInput({
    form,
    disabled: false,
    visible: true,
    key: "message",
    label: "Add message",
    placeholder: "Type message",
  });

  const handleCancel = () => onClose();

  const handleSubmit = () => {
    validateFields(async(err, values) => {
      if (err) return;

      const emailList = values.emailList;
      const subject = values.subject;
      const msg = values.message;
      const documentIds = Object.keys(isDeleted)
        .filter(idx => !isDeleted[idx])
        .map(idx => {
          return documents[idx].id;
        });

      const payload: typeof ApiDto.ShareDocumentMail = {
        toEmailList: emailList,
        subject,
        message: msg,
        documentIds,
      };

      const response = await shareDocuments(shipmentId, payload);
      if (response.isSuccess) {
        message.success('Documents shared successfully');
      } else {
        message.error(response.errorMessage);
      }

      onClose();
    });
  };

  const [isDeleted, setIsDeleted] = React.useState(documents.map(_ => false))

  const emailValidator = (rule, value, callback) => {
    let flag = false;
    if (value && value.length) {
      for (let i = 0; i < value.length; i += 1) {
        if (!validateEmail(value[i])) {
          flag = true;
          break;
        }
      }
    } else {
      callback(`Please provide a valid email`);
    }
    if (flag) callback('Some emails are invalid!!!');
    else callback();
  };

  const drawerTitle = () => (
    <div className={classes.contentDiv}>
      <div>
        <Icon type="close" onClick={handleCancel} />
        <span style={{ marginLeft: 10, fontSize: 20, fontWeight: 500 }}>Share Document(s)</span>
      </div>
    </div>
  )

  const renderFooter = () => {
    return <div
    style={{
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e8e8e8',
      padding: '10px 16px',
      textAlign: 'left',
      left: 0,
      background: '#fff',
      borderRadius: '0 0 4px 4px',
      display: 'flex',
      justifyContent: 'space-between',
    }}
    >
      <div></div>
      <div>
      <a
        onClick={handleCancel}
        style={{ width: 80, marginRight: 20, color: '#000' }}>
        Cancel
      </a>
      <Button
        type="primary"
        onClick={handleSubmit}
        style={{ width: 80 }}>
        Send
      </Button>
      </div>
    </div>;
  };

  const renderMailInfoGrid = () => {
    return <div className={classes.tableGrid}>
      
      <span>To<Asterisk /></span>
      <Form.Item>
      {
        getFieldDecorator('emailList', {
          rules: [{
            validator: emailValidator,
          }],
        })(<TagsInput
          style={{ width: '100%' }}
          placeholder={'Type email id'}
          notFoundContent={''}
          tokenSeparators={[' ']}
        ></TagsInput>)
      }
      </Form.Item>

      <span>{subject.label}<Asterisk /></span>
      {subject.decorator(<Input />)}

      <span>{addMessage.label}</span>
      {addMessage.decorator(<Input.TextArea />)}

    </div>;
  };

  const renderDocuments = () => {
    return <div>
      <div style={{ marginBottom: 5 }}>Document(s)</div>
      <ol style={{ marginBottom: 50,maxHeight: 'calc(100vh - 380px)', overflowX: 'auto' }}>
      {documents.map((doc, ind) => {
        return !isDeleted[ind] && <li><div style={{ 
          width: "100%",
          display: "flex",
          flexDirection: "row"}}>
          {/* <Icon type='paper-clip' /> */}
          <a
            href={doc.url}
            style={{
              marginLeft: 3,
              maxWidth: "90%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {doc.fileName} ({doc.documentType})
          </a>
          <Icon type="cross"
            style={{
              color: 'red', cursor: 'pointer',
              marginLeft: '1%', marginTop: '3px',
            }} onClick={() => {
              setIsDeleted({
                ...isDeleted,
                [ind]: true,
              });
            }}
          />
        </div></li>;
      })}
      </ol>
    </div>;
  };

  const renderLine = () => {
    return <hr className={classes.hrElement} />;
  };

  return <div>
    <Drawer
      className={classes.drawer}
      visible={visible}
      closable={false}
      width='500px'
      height='500px'
      title={drawerTitle()}
      onClose={handleCancel}
      >
      
      {renderMailInfoGrid()}
      {renderLine()}
      {renderDocuments()}
      
      {renderFooter()}
    </Drawer>
  </div>;
};

const options: HocOptions = {
  connectForm: {
    useForm: true,
  },
  connectJss: {
    useJss: true,
    styleSheet: styles,
  },
};

const SEDocumentsShareModalWithHOC = GenericHoc(options)(SEDocumentsShareModal);
export default SEDocumentsShareModalWithHOC;
